import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { WaybillIdView } from '../../../../models/shipment-id-view.model';
import { ShipmentWaybillEndpoint } from '../../constants';
import { WaybillTrackingMap } from '../../../../models/waybill-tracking-map.model';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillTrackingMapService {
  constructor(private http: WrapperHttpService) {}

  getShipmentWaybillTrackingMapData(waybillIdView: WaybillIdView): Observable<WaybillTrackingMap> {
    const url = `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
      ShipmentWaybillEndpoint.TrackingMap
    }?${getQueryStringFromObject({
      ...waybillIdView,
    })}`;

    return this.http.withLoading().get<WaybillTrackingMap>(url);
  }
}
